import AssessmentServiceApi from "../../services/assessment-api";

const getAssessmentAttemptByUserId = (userGuid, languageCode) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getAssessmentAttemptByUserId(
      userGuid,
      languageCode
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getAssessment = (languageCode) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getAssessment(languageCode)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const shareReportOnEmail = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.shareReportOnEmail(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const deleteReport = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.deleteReport(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getInsightfulContent = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getInsightfulContent(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const sendToFriendReportOnEmail = (data) => {
  return function () {
    return AssessmentServiceApi.sendToFriendReportOnEmail(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => {
        console.error("Error sending report email:", error);
        throw error;
      });
  };
};

const sendToPartnerReportOnEmail = (data) => {
  return function () {
    return AssessmentServiceApi.sendToPartnerReportOnEmail(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => {
        console.error("Error sending report email:", error);
        throw error;
      });
  };
};

const isCompleteRomanticCompatibility = (assessmentMapId) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.isCompleteRomanticCompatibility(assessmentMapId)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getUserAssessmentResultMapByUserId = (userId) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getUserAssessmentResultMapByUserId(userId)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getUserAssessmentResultByResultId = (id, currentLocale) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getUserAssessmentResultByResultId(
      id,
      currentLocale
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getBadges = ({ badgeType, currentLocale }) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getBadges({ badgeType, currentLocale })
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const saveUserSocialButtonClick = (data) => {
  return function () {
    return AssessmentServiceApi.saveUserSocialButtonClick(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Guest User Error", error));
  };
};

const getUserSocialButtonClickByUserId = (userId) => {
  return function () {
    return AssessmentServiceApi.getUserSocialButtonClickByUserId(userId)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Guest User Error", error));
  };
};

export {
  getAssessmentAttemptByUserId,
  getAssessment,
  shareReportOnEmail,
  deleteReport,
  getInsightfulContent,
  sendToFriendReportOnEmail,
  sendToPartnerReportOnEmail,
  isCompleteRomanticCompatibility,
  getUserAssessmentResultMapByUserId,
  getUserAssessmentResultByResultId,
  getBadges,
  saveUserSocialButtonClick,
  getUserSocialButtonClickByUserId,
};
